import React from "react";

import { SvgHome, SvgPlace2 } from "@routes/IconeSvg";

import ButtonGroupPlaceStatus from "./ModalHourCreate/subComponents/ButtonGroupPlaceStatus";

export default function TeleworkButton({
  value,
  onClickOffice,
  onClickRemote
}) {
  return (
    <div className="arh-mb-6 arh-flex arh-w-full arh-justify-center">
      <div className="button_container arh-flex !arh-w-full arh-justify-between arh-font-poppins arh-text-xs arh-font-medium">
        <ButtonGroupPlaceStatus
          icon={SvgHome({
            color: Boolean(value) ? "#ef3b60" : "#292929"
          })}
          onClick={() => onClickOffice(true)}
          classActive={Boolean(value) ? "remote" : "normal"}
          text="Télétravail"
        />
        <ButtonGroupPlaceStatus
          icon={SvgPlace2({
            color: !Boolean(value) ? "#F55611" : "#292929"
          })}
          classActive={!Boolean(value) ? "inplace" : "normal"}
          text="Sur Place"
          onClick={() => onClickRemote(false)}
        />
      </div>
    </div>
  );
}
